import { skipToken } from '@apollo/client/react'
import { useGlobalPermissions, useUnseenNotificationsCount } from '@lopo-tech/lopo-api'
import { NOTIFICATIONS_FETCH_INTERVAL } from 'src/constants/notifications'

export const usePollUnseenNotificationsCount = () => {
  const { canShowNotifications } = useGlobalPermissions()

  const { count: unseenCount } = useUnseenNotificationsCount(canShowNotifications
    ? {
      pollInterval: NOTIFICATIONS_FETCH_INTERVAL * 1000
    }
    : skipToken)

  return unseenCount
}
